import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["name", "id", "aria-invalid", "aria-describedby"]
const _hoisted_2 = ["value", "selected"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "form__indicator"
}
const _hoisted_5 = ["id"]

import { FormOption } from "@/types/formOption";
import {validate, Status} from '@/validation'
import {required, Rule} from '@/validation/rules'
import {ref, watch} from "vue";
import { useI18n } from "vue3-i18n";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FormSelect',
  props: {
    name: {},
    modelValue: {},
    label: {},
    rules: {},
    options: {},
    noLabel: { type: Boolean }
  },
  emits: ["update:modelValue", "validated"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// eslint-disable-next-line
__expose({
  //to call validation in parent.
    validateInput
})

// eslint-disable-next-line
const emit = __emit;

const { t } = useI18n();
const status = ref<Status>( { valid: true });
const isRequired = !(props.rules != null && props.rules.length == 0);
const inputValue = ref<string>(props.modelValue as string);
watch(props, (newProps) => inputValue.value = newProps.modelValue)

function handleChange() {
  validateInput();
  emit("update:modelValue", inputValue.value);
}

function handleBlur() {
  validateInput()
}

function validateInput() {
  let validationRules = props.rules ? props.rules : [required]
  status.value = validate(inputValue.value, validationRules)

  emit("validated", props.name, status.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form__field", { error: !status.value.valid }])
  }, [
    _withDirectives(_createElementVNode("select", {
      name: _ctx.name,
      id: _ctx.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      onChange: handleChange,
      onBlur: handleBlur,
      "aria-invalid": !status.value.valid,
      "aria-describedby": `error__${_ctx.name}`
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.name,
          value: option.name,
          selected: _ctx.modelValue === option.name
        }, _toDisplayString(option.label), 9, _hoisted_2))
      }), 128))
    ], 40, _hoisted_1), [
      [_vModelSelect, inputValue.value]
    ]),
    (!_ctx.noLabel)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.name
        }, [
          _createTextVNode(_toDisplayString(_ctx.label ? _ctx.label : _ctx.name) + " ", 1),
          isRequired
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    (!status.value.valid)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "form__error-message",
          id: `error__${_ctx.name}`
        }, _toDisplayString(_unref(t)('validation.select')), 9, _hoisted_5))
      : _createCommentVNode("", true)
  ], 2))
}
}

})